import { FormControl, FormHelperText, Grid, MenuItem, Select, Typography } from "@mui/material"
import { ReactNode } from "react"
import { Body, Label } from "../../components/Typography/Typography"
import { FlightplanStatus } from "../../store/types/FlightPlansTypes"
import { useFlightplanEditStore } from "../../zstore/FlightplanEditStore"
import { useFlightplanEditorStyles } from "./FlightplanEditorStyles"

const statusOptions: { label: FlightplanStatus; description: ReactNode }[] = [
    {
        label: FlightplanStatus.Active,
        description:
            "Flightplan is currently in use in acquisition. New logs can use this flightplan, and unflown lines should count against the % complete calculation for the project.",
    },
    {
        label: FlightplanStatus.Inactive,
        description:
            "Flightplan is not currently in use in acquisition. New logs cannot use this flightplan, and unflown lines should not count against the % complete calculation for the project.",
    },
    {
        label: FlightplanStatus.Complete,
        description: (
            <>
                Flightplan will never be used in acquisition again. New logs cannot use this flightplan, and{" "}
                <Typography display="inline" color={"error"}>
                    {" "}
                    unflown lines will be deleted.
                </Typography>
            </>
        ),
    },
]

interface FlightplanStatusSelectProps {
    isEditFlow: boolean
    onChange: (status?: FlightplanStatus) => void
}

export const FlightplanStatusSelect = ({ onChange, isEditFlow }: FlightplanStatusSelectProps) => {
    const { classes } = useFlightplanEditorStyles()
    const selectedFlightplan = useFlightplanEditStore((state) => state.selectedFlightplan)

    return (
        <>
            <Label gutterBottom="sm">Flightplan Status</Label>
            <FormControl sx={{ mb: 2 }}>
                <Select
                    variant={"outlined"}
                    value={selectedFlightplan.status || ""}
                    onChange={(e) => {
                        if (e.target.value) {
                            onChange(e.target.value as FlightplanStatus)
                        } else {
                            onChange(undefined)
                        }
                    }}
                >
                    {statusOptions.map((statusOpt) => (
                        <MenuItem
                            key={statusOpt.label}
                            value={statusOpt.label}
                            disabled={statusOpt.label === FlightplanStatus.Complete && !isEditFlow}
                        >
                            <Grid container>
                                <Grid item sm={2} xs={3} className={classes.status_label}>
                                    <Body disableGutter className={classes.status_label__text}>
                                        {statusOpt.label} -
                                    </Body>
                                </Grid>
                                <Grid item sm xs className={classes.status_description}>
                                    {statusOpt.description}
                                </Grid>
                            </Grid>
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>Required</FormHelperText>
            </FormControl>
        </>
    )
}
